<template>
  <div class="sidebar">
    <el-menu
      class="sidebar-el-menu"
      :collapse="collapse"
      :default-active="onRoutes"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#FFFFFF"
      unique-opened
      router
      @select="handleOpen"
    >
      <template v-for="(item, index) in limitsList" :key="index">
        <template v-if="item.child">
          <el-sub-menu :index="item.url" v-if="updateSign">
            <template #title>
              <i class="iconfont" :class="item.icon"></i>
              <span
                :class="{
                  isActive: activeMenu == item.url,
                }"
                >{{ item.title }}</span
              >
            </template>

            <el-menu-item
              style="padding-left: 60px"
              v-for="(subItem, subIndex) in item.child"
              :index="subItem.url"
              :key="subIndex"
              @click="handleSelMenuItem(subItem)"
            >
              <i class="iconfont" :class="subItem.icon"></i>

              {{ subItem.title }}
            </el-menu-item>
          </el-sub-menu>
        </template>
        <template v-else>
          <el-menu-item :index="item.url" :key="item.id">
            <i class="iconfont icon-houtai_caidan_zhangdan" :class="item.icon"></i>
            <template #title>{{ item.title }}</template>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeMenu: '',
    };
  },
  created() {
    this.handleOpen();
  },
  computed: {
    // 权限菜单
    limitsList() {
      return this.$store.getters.getSideRouter;
    },

    onRoutes() {
      return this.$route.path ? this.$route.path : '';
    },

    collapse() {
      return this.$store.state.collapse;
    },

    updateSign() {
      return this.$store.getters.getUpdateSign;
    },
  },
  methods: {
    handleSelMenuItem(e) {
      localStorage.setItem('limits', JSON.stringify(e.child));
    },
    handleOpen(value) {
      if (this.limitsList.length) {
        let openName = value ? value : this.$route.path;
        for (let item of this.limitsList) {
          if (item.child) {
            for (let itemc of item.child) {
              if (openName == itemc.url) {
                this.activeMenu = item.url;
              }
            }
          }
        }
      } else {
        this.handleOpen();
      }
    },
  },
};
</script>

<style scoped>
.isActive {
  color: #ffffff !important;
  font-weight: bold;
}
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 60px;
  bottom: 0;
  overflow-y: scroll;
  background-color: #324157;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 180px;
}

.sidebar > ul {
  height: 100%;
}

.el-menu-item.is-active {
  background-color: #283446 !important;
  color: #409eff !important;
  width: 180px !important;
}

.iconfont {
  margin-right: 10px;
  font-size: 14px;
  color: #ffffff;
}

.el-submenu__title {
  padding-left: 20px !important;
}

.el-menu-item {
  padding-left: 40px !important ;
}

.el-submenu .el-menu-item {
  min-width: 0;
}
</style>
